import React from 'react';
import { AuthenticatedPageLayout } from '@/components/layouts/AuthenticatedPageLayout';
import { RelationshipsView } from '@/components/views/RelationshipsView';

export const RelationshipsPage = () => (
	<AuthenticatedPageLayout>
		<RelationshipsView />
	</AuthenticatedPageLayout>
);
